export const P00058BathingTimerEnum = (t: any) => {
  let res = [];

  for (let i = 15; i <= 180; i = i + 15) {
    res.push({ ref: i, label: i + ' ' + t.instant('time.minut') });
  }

  return res;
};
